module.exports = __webpack_public_path__ + "img/021.2e0bf854.png";